











import { Component, Vue } from 'vue-property-decorator';
import { FitLoading, FitDialog } from '@/fit-components';
import { reportIndexPvUvAndTimeCost } from '@tencent/ppd-base-libs'
import sdk from '@/business/sdk';

@Component({
  components: {
    FitLoading,
    FitDialog,
  },
})
export default class App extends Vue {
  private created() {
    reportIndexPvUvAndTimeCost();
    sdk.disableCopyUrl();
    return;
  }
}
